import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../../core/layout/Dialog';
import { Link } from 'react-router';
import Button from '../../../../core/form/Button';

const BillReminderDialog = (props) => (
  <Dialog
    title="Billing reminder"
    onCancel={props.onClose}
    actions={[<Button icon="warning" onClick={props.onClose} key="onOk" label="OK" />]}
    isOpen={props.isOpen}
  >
    <p>
      <h3>Hi, how are you?</h3>
      We found that you have a bill that dues tomorrow. You can find the payment link in the{' '}
      <Link to="/billing">
        <b>Billing</b>
      </Link>{' '}
      menu.
      <br />
      <br />
      In case of any doubt, we are here to help you by <a href="mailto:financeiro@flexge.com">
        financeiro@flexge.com
      </a>{' '}
      or <a href="https://api.whatsapp.com/send?phone=553491530981">whatsapp (+553491530981)</a>.
    </p>
  </Dialog>
);

BillReminderDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};

BillReminderDialog.defaultProps = {
  isOpen: false,
};

export default BillReminderDialog;
